module.exports = __webpack_public_path__ + "img/chamcong.4e213b50.png";